require('./vendor/jquery.visible');
require('./vendor/jquery.detect_swipe');
require('./vendor/featherlight');
require('./vendor/featherlight.gallery');
require('./scripts');
require('./animation');
require('./video');